/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import { Snackbar } from "@material-ui/core";
import axios from "axios";
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { shallowEqual, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useSubheader } from "../../../../_metronic/layout";
import { CourseListSelection } from "../../SelectionWidgets/CourseListSelection";
import { InstructorListSelection } from "../../SelectionWidgets/InstructorListSelection";
import { SnackbarWrapper } from "../../Snackbar/SnackbarWrapper";
import { BatchEditForm } from "./Components/BatchEditForm";

const initBatch = {
  start_time: "",
  end_time: "",
  day: "Monday",
  maximum_student: "",
  branch_id: "",
  active_id: "1",
  delivery_type_id: "1",
  enrolled_student_count: 0,
  program_type_id: "1",
  batch_full_ind: "0",
};

export function BatchEdit({
  history,
  match: {
    params: { id, duplicate, dest_id },
  },
}) {
  // Subheader
  const suhbeader = useSubheader();

  //batch data
  const [data, setData] = useState();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const [successOpen, setSuccessOpen] = useState(false);
  const [editSuccessOpen, setEditSuccessOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [editErrorOpen, setEditErrorOpen] = useState(false);
  const [editErrorMessage, setEditErrorMessage] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [batchCourses, setBatchCourses] = useState([]);
  const [batchMissingCourses, setBatchMissingCourses] = useState([]);
  const [coursesToRemove, setCoursesToRemove] = useState([]);
  const [batchInstructors, setBatchInstructors] = useState([]);
  const [batchMissingInstructors, setBatchMissingInstructors] = useState([]);
  const [coursesToAdd, setCoursesToAdd] = useState([]);
  const [coachesToRemove, setCoachesToRemove] = useState([]);
  const [coachesToAdd, setCoachesToAdd] = useState([]);
  // Times currently in the Basic info form, which may differ from what is saved.
  const [pendingSchedule, setPendingSchedule] = useState(null);
  // { unpriced: [...], regressions: [...] } from the server, re-checked against
  // pendingSchedule. Null until the first check comes back.
  const [feeCheck, setFeeCheck] = useState(null);
  const btnRef = useRef();
  //console.log(id);

  //getbranch
  const branch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual,
  );

  initBatch.branch_id = branch.branch_id;

  useEffect(() => {
    //TODO: fetch details for editing batch here
    const getBatchInfo = async () => {
      const batch_info_url = `api/batches/${id}`;
      const res = await axios(batch_info_url);
      setData(res.data.results[0]);
    };
    id && getBatchInfo();
  }, [id]);

  useEffect(() => {
    let _title = id ? "" : "New Batch";
    if (id && duplicate) {
      _title = `Duplicate Batch`;
    } else if (id) {
      _title = `Edit Batch - ${id}`;
    }

    setTitle(_title);
    suhbeader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    setIsSaving(false);
  }, [id, duplicate, dest_id]);

  //Get List of courses not in batch
  useEffect(() => {
    const getMissingCourses = async () => {
      try {
        const courses_url = `api/batches/courses/missing/${id}`;
        const res = await axios(courses_url);
        setBatchMissingCourses(res.data.results);
        // console.log(res.data.results);
      } catch (e) {
        console.log(e);
      }
    };
    id && getMissingCourses();
  }, [id]);

  //Get list of courses in Batch
  useEffect(() => {
    const getCourses = async () => {
      try {
        const courses_url = `api/batches/courses/${id}`;
        const res = await axios(courses_url);
        setBatchCourses(res.data.results);
        dest_id
          ? setCoursesToAdd(
              res.data.results.map((c) => {
                return { id: c.course_id, show_ind: c.show_ind };
              }),
            )
          : setCoursesToAdd(coursesToAdd);
        // console.log(res.data.results);
      } catch (e) {
        console.log(e);
      }
    };
    id && getCourses();
  }, [id, dest_id]);

  // Re-check pricing whenever the schedule being edited changes. The fee_exists
  // flags on the course lists reflect the *stored* times, so without this the
  // Streams tab keeps refusing a course the save would now accept — and the
  // tooltip telling the admin to change the batch time would be unfollowable.
  const handleScheduleChange = useCallback((schedule) => {
    setPendingSchedule((prev) =>
      prev &&
      prev.start_time === schedule.start_time &&
      prev.end_time === schedule.end_time &&
      prev.delivery_type_id === schedule.delivery_type_id
        ? prev
        : schedule,
    );
  }, []);

  const courseIdsToCheck = useMemo(
    () =>
      [
        ...batchCourses.map((c) => c.course_id),
        ...batchMissingCourses.map((c) => c.course_id),
      ].filter((cid) => cid != null),
    [batchCourses, batchMissingCourses],
  );

  useEffect(() => {
    if (!id || !pendingSchedule || courseIdsToCheck.length === 0) return;

    const { start_time, end_time, delivery_type_id } = pendingSchedule;
    if (!start_time || !end_time) return;

    // ScheduleWatcher fires once on mount with the stored values. Re-checking
    // those would just reproduce the fee_exists flags the lists already carry,
    // at the cost of a round trip on every page open.
    const unchanged =
      data &&
      String(start_time) === String(data.start_time) &&
      String(end_time) === String(data.end_time) &&
      String(delivery_type_id) === String(data.delivery_type_id);
    if (unchanged) {
      setFeeCheck(null);
      return;
    }

    let cancelled = false;
    // Debounced: the time inputs fire on every keystroke.
    const timer = setTimeout(async () => {
      try {
        const params = new URLSearchParams({
          course_ids: courseIdsToCheck.join(","),
          start_time,
          end_time,
        });
        if (delivery_type_id) params.set("delivery_type_id", delivery_type_id);

        const res = await axios(`api/batches/${id}/fee-check?${params}`);
        const payload = res.data?.data;
        // Spreading a missing body would leave feeCheck truthy with no
        // `unpriced`, and the render path calls .map on it — one odd 2xx (a
        // proxy answering with HTML, say) would blank the whole page.
        if (
          !Array.isArray(payload?.unpriced) ||
          !Array.isArray(payload?.regressions)
        ) {
          if (!cancelled) setFeeCheck(null);
          return;
        }

        // Remember what was asked about: a course added while this was in
        // flight was not covered, and must keep the flag it was loaded with
        // rather than being treated as priced by its absence from `unpriced`.
        if (!cancelled) {
          setFeeCheck({
            ...payload,
            checkedIds: new Set(courseIdsToCheck.map(Number)),
          });
        }
      } catch (e) {
        // A failed check must not block the save — fall back to whatever flags
        // the lists are currently carrying.
        if (!cancelled) setFeeCheck(null);
      }
    }, 400);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [id, pendingSchedule, courseIdsToCheck, data]);

  //Get List of instructors not in batch
  useEffect(() => {
    const getMissingInstructors = async () => {
      try {
        const instructors_url = `api/batches/instructors/missing/${id}`;
        const res = await axios(instructors_url);
        setBatchMissingInstructors(res.data.results);
        // console.log(res.data.results);
      } catch (e) {
        console.log(e);
      }
    };
    id && getMissingInstructors();
  }, [id]);

  //Get list of instructors in Batch
  useEffect(() => {
    const getInstructors = async () => {
      try {
        const instructors_url = `api/batches/instructors/${id}`;
        const res = await axios(instructors_url);
        setBatchInstructors(res.data.results);
        dest_id
          ? setCoachesToAdd(
              res.data.results.map((c) => {
                return c.instructor_id;
              }),
            )
          : setCoursesToAdd(coursesToAdd);
        // console.log(res.data.results);
      } catch (e) {
        console.log(e);
      }
    };
    id && getInstructors();
  }, [id, dest_id]);

  const saveBatch = async (values) => {
    setIsSaving(true);
    setEditErrorMessage("");
    values = values ? values : data;
    try {
      if (!id) {
        //save new batch post
        const batchesUrl = "api/batches";
        // const info = JSON.parse(localStorage.getItem("batch-form"));
        const result = await axios.post(batchesUrl, values);
        if (result.data != "failed") {
          // console.log("batch result 1: ", result);
          setSuccessOpen(true);
          setTimeout(() => {
            history.push(`/batches/${result.data}/edit-batch`);
          }, 1000);
        } else {
          setIsSaving(false);
          setErrorOpen(true);
        }
      } else if (id && duplicate && !dest_id) {
        //save new duplicated batch post w/ coaches and courses
        const batchesUrl = "api/batches/duplicate";
        values.maximum_student = data.maximum_student;
        values.maximum_trial_student = data.maximum_trial_student;
        values.maximum_makeup_student = data.maximum_makeup_student;
        values.courses = batchCourses.map((c) => {
          return { id: c.course_id, show_ind: c.show_ind };
        });
        values.instructors = batchInstructors.map((i) => i.instructor_id);
        const result = await axios.post(batchesUrl, values);
        if (result.data != "failed") {
          setSuccessOpen(true);
          setTimeout(() => {
            history.push(`/batches/${result.data}/edit-batch`);
          }, 1000);
        } else {
          setIsSaving(false);
          setErrorOpen(true);
        }
      } else {
        // console.log("Remove Courses", coursesToRemove);
        // console.log("Add Courses", coursesToAdd);
        // console.log("Remove Inst", coachesToRemove);
        // console.log("Add Inst", coachesToAdd);

        // const info = JSON.parse(localStorage.getItem("batch-form"));
        // console.log("values", info);
        const send_data = {
          remove_courses: coursesToRemove,
          edit_courses: batchCourses,
          add_courses: coursesToAdd,
          remove_inst: coachesToRemove,
          add_inst: coachesToAdd,
          values: values,
        };
        // console.log(send_data);
        //edit batch post
        const editBatchUrl = `api/batches/`;
        const result = await axios.patch(editBatchUrl, send_data);
        // console.log(result)
        if (result.data === "success") {
          console.log("batch result 4: ", result);
          setEditSuccessOpen(true);
          setTimeout(() => {
            history.push("/batches/batch-list");
          }, 1000);
        } else {
          setIsSaving(false);
          setEditErrorOpen(true);
        }
      }
    } catch (error) {
      setIsSaving(false);
      // The server rejects a save that would leave a stream in this batch with
      // no fee at the batch's duration, as a 409 naming the duration and the
      // courses — far more use than the generic failure text. Matched on the
      // status, not just the presence of a message: on dev and UAT the global
      // error handler also returns { message }, so a 500 would otherwise be
      // reported as a pricing problem and swallow the rethrow.
      if (error?.response?.status === 409 && error?.response?.data?.message) {
        setEditErrorMessage(error.response.data.message);
        setEditErrorOpen(true);
        return;
      }

      // Anything else — a 500, a dropped connection — used to be rethrown into
      // Formik's onSubmit, which does not await saveBatch, so it surfaced as an
      // unhandled rejection in the console and nothing else. The button flipped
      // back from "Saving..." to "Save" and the admin was left guessing whether
      // it had worked.
      console.error("Batch save failed", error);
      setEditErrorMessage("");
      setEditErrorOpen(true);
    }
  };

  const handleClose = () => {
    setSuccessOpen(false);
    setErrorOpen(false);
    setEditErrorOpen(false);
    // editErrorMessage is deliberately left alone: the Snackbar keeps rendering
    // through its exit animation, and clearing it here swaps the real reason for
    // "Something went wrong" as it fades. It is reset when the next save starts.
  };

  const saveBatchClick = () => {
    if (isSaving || saveBlocked) {
      return;
    }
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    } else {
      saveBatch(null);
    }
  };

  const backToBatchList = () => {
    history.push(`/batches`);
  };

  // Once a fee-check has come back it is authoritative: it was run against the
  // times in the form, while fee_exists on the lists reflects what is stored.
  const unpricedIds = useMemo(
    () =>
      feeCheck
        ? new Set(feeCheck.unpriced.map((c) => Number(c.course_id)))
        : null,
    [feeCheck],
  );

  // CourseListSelection writes these derived objects back into raw state when the
  // admin toggles or moves a stream, so raw state ends up carrying the last
  // check's verdict rather than the load-time one. Harmless, because the check is
  // skipped outright while the schedule is unchanged — the load-time flags and
  // the check's answer are the same thing in that case.
  const withFeeStatus = useCallback(
    (list) =>
      unpricedIds
        ? list.map((c) =>
            feeCheck.checkedIds.has(Number(c.course_id))
              ? {
                  ...c,
                  fee_exists: unpricedIds.has(Number(c.course_id)) ? 0 : 1,
                }
              : c,
          )
        : list,
    [unpricedIds, feeCheck],
  );

  const shownBatchCourses = useMemo(
    () => withFeeStatus(batchCourses),
    [withFeeStatus, batchCourses],
  );
  const shownMissingCourses = useMemo(
    () => withFeeStatus(batchMissingCourses),
    [withFeeStatus, batchMissingCourses],
  );

  // Courses queued for this batch that have no price at its duration. Saving
  // them would enrol students with no fee attached, so the server rejects it —
  // block Save here so the admin sees why before clicking. coursesToAdd only
  // carries ids, so the flag is read off the course objects they came from.
  const unpricedAdds = coursesToAdd
    .map((add) => shownBatchCourses.find((c) => c.course_id === add.id))
    .filter((c) => c && c.fee_exists === 0);

  // Streams that will still be attached after this save. The fee-check is asked
  // about every course in the branch, because the right-hand pane needs a
  // fee_exists flag for each — but a regression only means anything for a course
  // that is actually in the batch. Without this filter the banner names courses
  // the admin never touched: 1057 of 1216 active batches have at least one
  // unattached candidate priced at their current duration, so Save would be
  // permanently disabled on nearly all of them. The server scopes its own check
  // to the attached streams, so this matches what it will actually reject.
  const attachedIds = useMemo(() => {
    const removing = new Set(coursesToRemove.map(Number));
    return new Set(
      batchCourses
        .map((c) => Number(c.course_id))
        .filter((cid) => !removing.has(cid)),
    );
  }, [batchCourses, coursesToRemove]);

  const retimeRegressions = (feeCheck?.regressions || []).filter((c) =>
    attachedIds.has(Number(c.course_id)),
  );

  const blockedCodes = [
    ...new Set(
      [...unpricedAdds, ...retimeRegressions].map((c) => c.course_code),
    ),
  ];
  const saveBlocked = blockedCodes.length > 0;

  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={
          successOpen
            ? successOpen
            : editSuccessOpen
            ? editSuccessOpen
            : errorOpen
            ? errorOpen
            : editErrorOpen
        }
        autoHideDuration={editErrorMessage ? 8000 : 3000}
        onClose={handleClose}
      >
        <SnackbarWrapper
          onClose={handleClose}
          variant={successOpen || editSuccessOpen ? "success" : "error"}
          message={
            successOpen
              ? "Added the batch successfully"
              : editSuccessOpen
              ? "Edited the batch successfully"
              : editErrorMessage
              ? editErrorMessage
              : "Something went wrong"
          }
        />
      </Snackbar>
      <Card>
        {/* {actionsLoading && <ModalProgressBar />} */}
        <CardHeader title={title}>
          <CardHeaderToolbar>
            <button
              type="button"
              onClick={backToBatchList}
              className="btn btn-light"
            >
              <i className="fa fa-arrow-left"></i>
              Back
            </button>
            {`  `}
            <button
              type="submit"
              className="btn btn-primary ml-2"
              disabled={isSaving || saveBlocked}
              onClick={saveBatchClick}
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {saveBlocked && (
            <div className="alert alert-custom alert-light-danger mb-5" role="alert">
              <div className="alert-icon">
                <i className="fa fa-exclamation-triangle text-danger"></i>
              </div>
              <div className="alert-text">
                No pricing exists for this batch's duration for{" "}
                <strong>{blockedCodes.join(", ")}</strong>.{" "}
                {retimeRegressions.length > 0
                  ? "These streams are priced at the batch's current time. Add a fee for the new duration under Branch Courses, or keep the existing time."
                  : "Add a fee for that duration under Branch Courses, change the batch time to one that is already priced, or remove the stream."}
              </div>
            </div>
          )}
          <ul className="nav nav-tabs nav-tabs-line " role="tablist">
            <li className="nav-item" onClick={() => setTab("basic")}>
              <a
                className={`nav-link ${tab === "basic" && "active"}`}
                data-toggle="tab"
                role="tab"
                aria-selected={(tab === "basic").toString()}
              >
                Basic info
              </a>
            </li>
            {((id && !duplicate) || (id && duplicate && dest_id)) && (
              <>
                {" "}
                <li className="nav-item" onClick={() => setTab("coaches")}>
                  <a
                    className={`nav-link ${tab === "coaches" && "active"}`}
                    data-toggle="tab"
                    role="button"
                    aria-selected={(tab === "coaches").toString()}
                  >
                    Coaches
                  </a>
                </li>
                <li className="nav-item" onClick={() => setTab("courses")}>
                  <a
                    className={`nav-link ${tab === "courses" && "active"}`}
                    data-toggle="tab"
                    role="tab"
                    aria-selected={(tab === "courses").toString()}
                  >
                    Streams
                  </a>
                </li>
              </>
            )}
          </ul>
          <div className="mt-5">
            {/* Hidden rather than unmounted. Unmounting threw away every
                unsaved Basic info field the moment you clicked another tab, and
                nulled btnRef with it — so Save fell through to saveBatch(null),
                which posts the row fetched on mount and reports success while
                silently dropping the edit. Keeping it mounted also makes the
                schedule the Streams tab checks against the schedule the save
                will actually send. */}
            <div style={{ display: tab === "basic" ? undefined : "none" }}>
              <BatchEditForm
                //actionsLoading={actionsLoading}
                //Pass in the edit batch OR new batch
                batch={data ? data : initBatch}
                btnRef={btnRef}
                saveBatch={saveBatch}
                onScheduleChange={id ? handleScheduleChange : undefined}
                submitDisabled={saveBlocked}
              />
            </div>
            {tab === "coaches" && id && (
              <div>
                {" "}
                <InstructorListSelection
                  id={id}
                  type={"batch"}
                  setCoachesToAdd={setCoachesToAdd}
                  coachesToAdd={coachesToAdd}
                  coachesToRemove={coachesToRemove}
                  setCoachesToRemove={setCoachesToRemove}
                  batchInstructors={batchInstructors}
                  setBatchInstructors={setBatchInstructors}
                  batchMissingInstructors={batchMissingInstructors}
                  setBatchMissingInstructors={setBatchMissingInstructors}
                />
              </div>
            )}
            {tab === "courses" && id && (
              <div>
                {" "}
                <CourseListSelection
                  id={id}
                  type={"batch"}
                  setCoursesToAdd={setCoursesToAdd}
                  coursesToAdd={coursesToAdd}
                  setCoursesToRemove={setCoursesToRemove}
                  coursesToRemove={coursesToRemove}
                  batchCourses={shownBatchCourses}
                  setBatchCourses={setBatchCourses}
                  batchMissingCourses={shownMissingCourses}
                  setBatchMissingCourses={setBatchMissingCourses}
                />{" "}
              </div>
            )}
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
}
